import React, { useEffect, useRef } from 'react';

const AngularAppEmbed = ({ groupId, authToken }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    // Send auth data to Angular app once loaded
    const handleIframeLoad = () => {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.postMessage(
          {
            type: 'AUTH_DATA',
            groupId,
            authToken,
          },
          '*' // In production, specify your domain
        );
      }
    };

    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener('load', handleIframeLoad);
      return () => iframe.removeEventListener('load', handleIframeLoad);
    }
  }, [groupId, authToken]);

  return (
    <iframe
      ref={iframeRef}
      src={`/angular-app/index.html?groupId=${groupId}`}
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        display: 'block'
      }}
      title="YaBuddy Group App"
    />
  );
};

export default AngularAppEmbed;
